export default {
  sizes: {
    '3xs': {
      content: {
        width: '3xs',
      },
    },
    '2xs': {
      content: {
        width: '2xs',
      },
    },
    xs: {
      content: {
        width: 'xs',
      },
    },
    sm: {
      content: {
        width: 'sm',
      },
    },
    md: {
      content: {
        width: 'md',
      },
    },
    lg: {
      content: {
        width: 'lg',
      },
    },
    xl: {
      content: {
        width: 'xl',
      },
    },
    '2xl': {
      content: {
        width: '2xl',
      },
    },
    '3xl': {
      content: {
        width: '3xl',
      },
    },
    '4xl': {
      content: {
        width: '4xl',
      },
    },
    '5xl': {
      content: {
        width: '5xl',
      },
    },
    '6xl': {
      content: {
        width: '6xl',
      },
    },
    '7xl': {
      content: {
        width: '7xl',
      },
    },
    '8xl': {
      content: {
        width: '8xl',
      },
    },
  },
  defaultProps: {
    size: 'xs',
  },
  baseStyle: {
    popper: {
      bg: 'white',
    },
    content: {
      color: 'black',
    },
  },
};
